import * as Switch from "@radix-ui/react-switch";
import { useState, useEffect } from "react";
import axiosInstance from "../../reactWrapper/endpoints/axios";
import { toast } from "react-toastify";
import ButtonSpinner from "../../components/Loader/ButtonSpinner";

export default function ScoutToggle() {
  const [enabled, setEnabled] = useState(false);
  const [loading, setLoading] = useState(true);
  const [updating, setUpdating] = useState(false);

  // Fetch initial state
  useEffect(() => {
    const fetchState = async () => {
      try {
        const response = await axiosInstance.get("/admin/getScoutDiscount");
        if (response.data.status) {
          setEnabled(response.data.data?.state === 1);
        }
      } catch (error) {
        console.error("Failed to fetch scout discount state:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchState();
  }, []);

  const handleToggle = async (checked) => {
    setUpdating(true);
    try {
      const response = await axiosInstance.post("/admin/updateScoutDiscount", {
        state: checked,
      });

      if (response.data.status) {
        setEnabled(checked);
        toast.success(response.data.message || "Setting updated successfully");
      } else {
        toast.error(response.data.message || "Failed to update setting");
      }
    } catch (error) {
      toast.error("An error occurred while updating the setting");
      console.error(error);
    } finally {
      setUpdating(false);
    }
  };

  if (loading) {
    return (
      <div className="flex items-center gap-2 text-sm text-gray-500">
        <ButtonSpinner /> Loading setting...
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-3">
      <div className="flex items-center justify-between">
        <div className="flex flex-col">
          <p className="text-sm font-medium text-gray-700">Enable Scout Discount</p>
          <p className="text-xs text-gray-500">
            Toggles free CV access and 50/50 applied talent redaction.
          </p>
        </div>

        <div className="flex items-center gap-3">
          {updating && <ButtonSpinner />}
          <Switch.Root
            checked={enabled}
            onCheckedChange={handleToggle}
            disabled={updating}
            className={`w-10 h-6 rounded-full relative transition ${
              enabled ? "bg-green-500" : "bg-gray-300"
            } ${updating ? "opacity-50 cursor-not-allowed" : "cursor-pointer"}`}
          >
            <Switch.Thumb
              className={`block w-5 h-5 bg-white rounded-full shadow transition transform ${
                enabled ? "translate-x-4" : "translate-x-1"
              }`}
            />
          </Switch.Root>
        </div>
      </div>
    </div>
  );
}